import {action, makeObservable} from 'mobx';
import {Collection} from '../../Common/stores/Collection';
import {DesignField} from './DesignField';

export class DesignCollection extends Collection {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    insertFields(parentField, children) {
        this.fields.clear();
        children.forEach(f => {
            const newField = new DesignField(f, parentField);
            newField.setCollection(f);
            this.fields.push(newField);
        });
    }

    //@computed
    get firstAvailableIdx() {
        return this.fields[0].general ? 1 : 0;
    }

    @action
    sortHidden() {
        const firstHiddenIdx = this.firstHiddenIdx;
        this.fields.forEach((field, idx) => {
            if (!field.hidden && idx >= firstHiddenIdx) {
                const removedField = this.fields.splice(idx, 1)[0];
                this.setField(removedField, firstHiddenIdx);
            }
        });
    }
}
